import { render } from "./book-suggest.vue?vue&type=template&id=1ff806a5&scoped=true"
import script from "./book-suggest.js?vue&type=script&lang=js&external"
export * from "./book-suggest.js?vue&type=script&lang=js&external"

import "./book-suggest.css?vue&type=style&index=0&id=1ff806a5&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff806a5"]])

export default __exports__